<div class="setup-container">
  <div class="setup-card">
    <div>
      <span><i class="bi bi-lightbulb me-2"></i>Skills</span>

      <p>
        <i class="bi bi-code-slash me-2"></i>
        Technical skills
      </p>

      <div class="selected-chips-row" *ngIf="selectedTopics.length > 0">
        <div class="chip" *ngFor="let topic of selectedTopics">
          {{ topic }}
          <mat-icon (click)="toggleTopic(topic)" class="close-icon"
            >close</mat-icon
          >
        </div>
      </div>
      <div class="search-box">
        <input
          type="text"
          placeholder="Add a techinal skill..."
          [(ngModel)]="topicInput"
          (keyup.enter)="addTopic()"
          maxlength="50"
        />
        <button class="add-btn" (click)="addTopic()">+ Add</button>
      </div>

      <div class="suggested-topics">
        <div *ngIf="isLoadingSkills" class="loader-box">
          <div class="spinner"></div>
          <p>Loading skills...</p>
        </div>

        <div class="topic-pills" *ngIf="!isLoadingSkills">
          <button
            *ngFor="let topic of filteredTopics()"
            class="pill-btn"
            [class.active]="selectedTopics.includes(topic)"
            (click)="toggleTopic(topic)"
          >
            <span class="icon-span">{{
              selectedTopics.includes(topic) ? "✓" : "+"
            }}</span>
            {{ topic }}
          </button>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <span>
        <i class="bi bi-tools me-2"></i>
        Tools & Technologies</span
      >
      <div class="selected-chips-row" *ngIf="selectedTechnologies.length > 0">
        <div class="chip" *ngFor="let topic of selectedTechnologies">
          {{ topic }}
          <mat-icon (click)="toggleTechnologyTopic(topic)" class="close-icon"
            >close</mat-icon
          >
        </div>
      </div>
      <div class="search-box">
        <input
          type="text"
          placeholder="Add a tools & technologies..."
          [(ngModel)]="technologyInput"
          (keyup.enter)="addTechnologyTopic()"
          maxlength="50"
        />
        <button class="add-btn" (click)="addTechnologyTopic()">+ Add</button>
      </div>

      <div class="suggested-topics">
        <div *ngIf="isLoadingSkills" class="loader-box">
          <div class="spinner"></div>
          <p>Loading tools...</p>
        </div>

        <div class="topic-pills" *ngIf="!isLoadingSkills">
          <button
            *ngFor="let topic of filteredTechnologiesTopics()"
            class="pill-btn"
            [class.active]="selectedTechnologies.includes(topic)"
            (click)="toggleTechnologyTopic(topic)"
          >
            <span class="icon-span">{{
              selectedTechnologies.includes(topic) ? "✓" : "+"
            }}</span>
            {{ topic }}
          </button>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <span>
        <i class="bi bi-people me-2"></i>
        Soft Skills</span
      >
      <div class="selected-chips-row" *ngIf="selectedSoftSkills.length > 0">
        <div class="chip" *ngFor="let topic of selectedSoftSkills">
          {{ topic }}
          <mat-icon (click)="toggleSoftSkillTopic(topic)" class="close-icon"
            >close</mat-icon
          >
        </div>
      </div>
      <div class="search-box">
        <input
          type="text"
          placeholder="Add a soft skill..."
          [(ngModel)]="skillInput"
          (keyup.enter)="addSoftSkillTopic()"
          maxlength="50"
        />
        <button class="add-btn" (click)="addSoftSkillTopic()">+ Add</button>
      </div>

      <div class="suggested-topics">
        <div *ngIf="isLoadingSkills" class="loader-box">
          <div class="spinner"></div>
          <p>Loading soft skills...</p>
        </div>
        <div class="topic-pills" *ngIf="!isLoadingSkills">
          <button
            *ngFor="let topic of filteredSoftSkillsTopics()"
            class="pill-btn"
            [class.active]="selectedSoftSkills.includes(topic)"
            (click)="toggleSoftSkillTopic(topic)"
          >
            <span class="icon-span">{{
              selectedSoftSkills.includes(topic) ? "✓" : "+"
            }}</span>
            {{ topic }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
